import { PropController } from "../prop-controllers/base";
import {
  isElementReference
} from "../state/react-page";
const SlotControlType = "makeswift::controls::slot";
function Slot() {
  return { type: SlotControlType };
}
const SlotControlMessageType = {
  CONTAINER_BOX_MODEL_CHANGE: "makeswift::controls::slot::message::container-box-model-change",
  ITEM_BOX_MODEL_CHANGE: "makeswift::controls::slot::message::item-box-model-change"
};
class SlotControl extends PropController {
  recv = () => {
  };
  changeContainerBoxModel(boxModel) {
    this.send({ type: SlotControlMessageType.CONTAINER_BOX_MODEL_CHANGE, payload: { boxModel } });
  }
  changeItemBoxModel(index, boxModel) {
    this.send({ type: SlotControlMessageType.ITEM_BOX_MODEL_CHANGE, payload: { index, boxModel } });
  }
}
function copySlotData(value, context) {
  if (value == null)
    return value;
  return {
    ...value,
    elements: value.elements.map((element) => context.copyElement(element))
  };
}
function mergeSlotData(base = { columns: [], elements: [] }, override = { columns: [], elements: [] }, context) {
  const mergedColumns = base.columns;
  const mergedElements = base.elements.flatMap((baseElement) => {
    const overrideElement = override.elements.find(
      (e) => baseElement.type === e.type && baseElement.key === e.key
    );
    if (overrideElement == null)
      return [baseElement];
    if (overrideElement.deleted)
      return [];
    if (isElementReference(overrideElement))
      return [overrideElement];
    if (isElementReference(baseElement))
      return [baseElement];
    return context.mergeElement(baseElement, overrideElement);
  });
  return { columns: mergedColumns, elements: mergedElements };
}
function mergeSlotControlTranslatedData(data, context) {
  return {
    ...data,
    elements: data.elements.map((element) => context.mergeTranslatedData(element))
  };
}
export {
  Slot,
  SlotControl,
  SlotControlMessageType,
  SlotControlType,
  copySlotData,
  mergeSlotControlTranslatedData,
  mergeSlotData
};
//# sourceMappingURL=slot.js.map